<script>
import { mapState } from 'vuex'
import Filter from '@/mixins/Filter'
import Location from '@/mixins/Location'
import Service from '@/services/ApiService'

export default {
  mixins: [Location, Filter],
  data () {
    return {
      currentFilter: {
        id: -1,
        name: 'Alle'
      },
      filters: [],
      isLoading: false,
      results: [],
      surroundings: [],
      total: 0
    }
  },
  computed: {
    ...mapState([
      'surrounding'
    ])
  },
  methods: {
    filterItems (filter, ref) {
      this.isLoading = true

      let items = this.filterDirectories(filter, this.surroundings)
      this.currentFilter = filter

      this.setPagination(items)
      this.$refs[ref].setPage(1)

      setTimeout(() => {
        this.isLoading = false
      }, 200)
    },
    setData (filter = null) {
      // reset filters
      let filterName = 'business'

      if (filter === 'webshop') {
        filterName = filter
      }

      this.$store.commit('setCurrentFilter', {
        name: filterName,
        filter: {
          id: -1,
          name: 'Alle'
        }
      })

      this.isLoading = true
      let url = 'community/' + this.surrounding.id + '/surroundings'

      Service.get(url).then((response) => {
        this.filters = [
          { id: -1, name: 'Alle' }
        ]

        response.forEach((surrounding) => {
          let position = null
          if (surrounding.demo === false && surrounding.id !== 9) {
            if (filter === 'webshop') {
              if (surrounding.webshop.id === undefined || surrounding.webshop.active === 0) {
                return
              }
            }

            this.surroundings.push(surrounding)

            if (surrounding.branche.id !== undefined) {
              position = this.filters.map((it) => {
                return it.id
              }).indexOf(surrounding.branche.id)
            }

            if (position === -1 && surrounding.branche.id !== undefined) {
              this.filters.push(surrounding.branche)
            }
          }
        })
        this.isLoading = false

        this.setPagination(this.surroundings)
      }, (err) => {
        console.warn(err)
        this.isLoading = false
      })
    },
    setPagination (items) {
      let surroundings = JSON.parse(JSON.stringify(items))

      let newItems = []
      let pos = 15

      while (true) {
        if (pos < surroundings.length) {
          let surroundingArray = surroundings.splice(0, pos)
          newItems.push(surroundingArray)
        } else {
          newItems.push(surroundings)
          break
        }
      }

      this.total = items.length
      this.results = newItems
    }
  }
}
</script>
